import script from "./SearchComp.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchComp.vue?vue&type=script&setup=true&lang=js"

import "./SearchComp.vue?vue&type=style&index=0&id=30630d3f&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30630d3f"]])

export default __exports__